import {Injectable} from "@angular/core";
import {
  MessageIssueDto,
  MessageIssuePreviewDto,
  SubmitMessageIssueDto
} from "@server-models";
import {Observable} from "rxjs";
import {SharedIssueApiService} from "@shared/components/issues/services/shared-issue-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";

@Injectable({
  providedIn: 'root',
})
export class LinkIssueMessageApiService extends SharedIssueApiService implements IIssueService {

  getIssuePreview(templateId: number): Observable<MessageIssuePreviewDto> {
    return super.get<MessageIssuePreviewDto>(`/tech/v2/issue/message/template/${ templateId }/preview`, undefined);
  }

  getIssue(issueId: number): Observable<MessageIssueDto> {
    return super.get<MessageIssueDto>(`/tech/v2/issue/message/${ issueId }/recent`);
  }

  sendIssueTemplatePreviewById(templateId: number, issue: SubmitMessageIssueDto): Observable<void> {
    return super.post<void>(`/tech/v2/issue/message/template/${ templateId }/submitIssue`, undefined, issue)
  }
}
